import { io } from "socket.io-client";
import { enterServicePanel } from "./socketRooms";
// import { useAuth } from "../context/AuthContext";
import { api } from "../api/api";
const BE_URL = process.env.REACT_APP_BE_URL2;

// console.log("🔗 BE_URL:", BE_URL);

// const token = localStorage.getItem("token");


export const createSocket = (token) => {

  // console.log("🔗 Creating socket with token:", token);
  const socket = io(BE_URL, {
    autoConnect: true,
    withCredentials: true,
    auth: { token },
  });

  socket.on("connect", () => {
    // console.log("✅ FE socket connected:", socket.id);
    // enterServicePanel(socket); 
  });

  socket.on("connect_error", async (err) => {
    // if (err.message === "jwt expired") {
    console.log("⚠️ Socket tokenı dolmuş, yenileniyor...");

    //   // 1. Backend'den yeni token iste (Refresh Token endpoint'in varsa)
    //   const res = await api.get(`/auth/refresh-token`); 
    //   const { newToken } = res.data;

    //   // 2. Fonksiyonu çağır
    //   refreshSocket(newToken);
    // }
  });

  return socket;
}
